/*
 * sola-facet-instock.js — make the collection/search filters reflect REAL availability.
 *
 * WHY: Shopify's server-rendered facet counts include sold-out products, so a size can look
 * available when every pair in it is already gone (clicking it then returns nothing — worse
 * here because picking a size auto-applies in-stock, see sola-instock-filter.js). Shopify gives
 * no per-value "in stock" count in Liquid, so we ask for the same facets computed WITH
 * `filter.v.availability=1` and use what survives as the source of truth for what's buyable.
 *
 * WHAT:
 *   • grey out (disable) any facet VALUE that has products in this collection but none in stock
 *   • hide any GROUP where nothing is in stock (e.g. Apparel Size under a sneakers collection)
 * Active selections and the Availability / Price facets are never touched.
 *
 * Re-runs after collection-filters.js swaps the facets/grid (MutationObserver on the section).
 * Its own edits are deep (classes/attrs), so they don't retrigger the observer.
 */
(function () {
  var root = document.querySelector('[data-section-id]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var AVAIL = 'filter.v.availability';
  var key = function (inp) { return inp.name + '=' + inp.value; };

  function inStockURL() {
    var u = new URL(location.pathname + location.search, location.origin);
    u.searchParams.set(AVAIL, '1');            // in-stock only
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  var busy = false;
  function apply() {
    if (busy) return;
    // When the URL already pins in-stock (availability=1 — the common case, since picking a
    // size auto-applies it), the server-rendered facets ARE the in-stock facets: the probe
    // would fetch the exact same section and no-op. Skipping it removes one full
    // fetch+parse+facet-walk from every filter tap's post-swap cascade (mobile INP).
    if (new URLSearchParams(location.search).get(AVAIL) === '1') return;
    var form = root.querySelector('[data-facets-form]');
    if (!form) return;
    busy = true;
    fetch(inStockURL(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Values that survive the in-stock computation (facets.liquid already drops count-0 ones).
        var live = {};
        doc.querySelectorAll('[data-facets-form] input[type=checkbox]').forEach(function (inp) {
          live[inp.name + '=' + inp.value] = true;
        });
        root.querySelectorAll('.facets__group').forEach(function (g) {
          var pn = g.getAttribute('data-filter') || '';
          if (pn.indexOf(AVAIL) === 0) return;                      // leave the Availability facet alone
          var boxes = [].slice.call(g.querySelectorAll('input[type=checkbox]'));
          if (!boxes.length) return;                                // price group
          var anyLive = false, anyActive = false;
          boxes.forEach(function (inp) {
            var lbl = inp.closest('label');
            if (inp.checked) { anyActive = true; return; }          // keep active selections usable
            if (live[key(inp)]) { anyLive = true; if (lbl) lbl.classList.remove('is-off'); inp.disabled = false; }
            else { if (lbl) lbl.classList.add('is-off'); inp.disabled = true; }  // has products, none in stock → grey
          });
          g.hidden = (!anyLive && !anyActive);                      // whole group has nothing in stock
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  // ---- Size chip on cards: show the SELECTED size (e.g. "10M/11.5W") only while a size
  //      filter is active, so a shopper filtering several sizes can tell cards apart. ----
  var activeSizes = [];
  function computeActiveSizes() {
    var out = [];
    root.querySelectorAll('.facets__group').forEach(function (g) {
      if (!/size/i.test(g.getAttribute('data-filter') || '')) return;   // size facets only
      g.querySelectorAll('input[type=checkbox]:checked').forEach(function (inp) {
        var t = inp.closest('label') && inp.closest('label').querySelector('.facets__size-lbl');
        if (t) out.push(t.textContent.trim());
      });
    });
    return out;
  }
  function paintCardSizes() {
    root.querySelectorAll('.sola-card[data-card-sizes]').forEach(function (card) {
      var pill = card.querySelector('.sola-card__size');
      if (!pill) return;
      var txt = '';
      if (activeSizes.length) {
        txt = (card.getAttribute('data-card-sizes') || '').split('|').filter(function (s) {
          return activeSizes.indexOf(s) >= 0;
        }).join(' · ');
      }
      if (pill.textContent !== txt) pill.textContent = txt;
      pill.hidden = !txt;
    });
  }

  function run() { activeSizes = computeActiveSizes(); apply(); paintCardSizes(); }
  new MutationObserver(run).observe(root, { childList: true });   // facet/grid swaps
  // Newly infinite-scrolled cards append deep in the grid — repaint their chips on scroll.
  // Only while a size filter is active: with none selected there is nothing to paint, and
  // walking every card on each scroll frame is pure waste (it grows with the infinite grid).
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!activeSizes.length || ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; paintCardSizes(); });
  }, { passive: true });
  run();
})();
